import React from 'react';
import './SessionExpiredModal.css';

export default function SessionExpiredModal({ onReauthorize }) {
  return (
    <div className="session-expired-overlay">
      <div className="session-expired-modal">
        <div className="session-expired-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <h2>Сессия истекла</h2>
        <p>Ваша сессия истекла. Пожалуйста, авторизуйтесь повторно для продолжения работы.</p>
        <button className="session-expired-button" onClick={onReauthorize}>
          Авторизоваться повторно
        </button>
      </div>
    </div>
  );
}

